/**
 * Driver API
 * 
 * Handles driver-related API calls including:
 * - Driver registration
 * - Driver info updates
 */

import api from './client';

export const driverApi = {
  /**
   * Submit driver registration info
   * @param {FormData} formData - Driver info form data (including files)
   * @returns {Promise<Object>} Driver data
   */
  async submitDriverInfo(formData) {
    const response = await api.post('/api/driver/info', formData);
    return response.data;
  },

  /**
   * Update driver info
   * @param {FormData} formData - Driver info form data
   * @returns {Promise<Object>} Updated driver data
   */
  async updateDriverInfo(formData) {
    const response = await api.patch('/api/driver/info', formData);
    return response.data;
  },
};

export default driverApi;
